import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastService } from "src/app/shared/toasts/toast-service";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";
import { ContactService } from "../../../../contact.service";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-create-contact-list-modal",
  templateUrl: "./create-contact-list-modal.component.html",
})
export class CreateContactListModalComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  createContactListForm!: FormGroup;
  loading = false;
  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private contactService: ContactService,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.createContactListForm = this.fb.group({
      descricaoLista: ["", Validators.required],
    });
  }

  onSubmit(): void {
    if (this.createContactListForm.invalid) {
      return;
    }
    this.loading = true;

    const data = this.createContactListForm.value;
    this.contactService
      .createContactList(data.descricaoLista)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.toastService.show("Lista criada com sucesso", {
            classname: "bg-success text-light",
          });
          this.activeModal.close();
        },
        error: () => {
          this.toastService.show("Erro ao criar lista", {
            classname: "bg-danger text-light",
          });
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
